import { motion } from "framer-motion";
import { STORE } from "@/lib/config";
import { useSettings } from "@/context/SettingsContext";

export default function About() {
  const years = new Date().getFullYear() - STORE.since;
  const { resolved } = useSettings();

  return (
    <section id="o-nama" data-testid="about-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="text-[#D32F2F] uppercase tracking-[0.25em] text-xs font-semibold mb-4">
              Od 2004.
            </div>
            <h2
              className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-neutral-900 leading-tight"
              style={{ fontFamily: "Cabinet Grotesk" }}
            >
              Naša priča —
              <span className="block text-[#D32F2F]">{years}+ godina povjerenja.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 space-y-5 text-neutral-700 text-lg leading-relaxed">
            <p>
              Otvorili smo vrata <strong>MOBY SHOP-a</strong> davne <strong>2002.</strong> godine
              u srcu Orašja, sa jednostavnom idejom: ponuditi kvalitetnu tehniku, knjige i školski
              pribor uz iskren odnos prema svakom kupcu.
            </p>
            <p>
              Više od <strong>15 godina nalazimo se na istoj lokaciji</strong> u 8. ulici — i to je
              razlog zašto su nam mnogi kupci postali stalni prijatelji. Generacije đaka, studenata
              i obitelji vraćaju nam se jer znaju da ćemo uvijek izdvojiti vrijeme za pravi savjet.
            </p>
            <p>
              Danas pod jednim krovom spajamo <strong>tehniku</strong>, <strong>knjižaru</strong>,
              <strong> servis mobitela</strong> i <strong>fiskalizaciju kasa</strong> — sve što
              gradu i okolici treba, na jednom mjestu, sa vlastitim skladištem i pravovremenom
              nabavkom.
            </p>
            <p>
              Nudimo <strong>širok asortiman</strong> od mobitela, laptopa i pametnih uređaja, preko
              kompletne školske opreme za sve razrede, do <strong>servisa i tehničke podrške</strong>
              — jer za nas MOBY SHOP nije samo trgovina, već <em>obiteljska priča</em> koju
              gradimo s vama već preko dva desetljeća.
            </p>
          </div>
        </div>

        {/* Gallery */}
        <div className="grid grid-cols-12 gap-4 sm:gap-6">
          {/* [USER] SLIKE LOKACIJE: zamjenjuju se preko Admin panela ili u /src/lib/config.js */}
          {resolved.historyGallery.map((src, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className={`relative overflow-hidden rounded-2xl ${
                i === 0
                  ? "col-span-12 md:col-span-7 aspect-[16/10]"
                  : i === 1
                  ? "col-span-6 md:col-span-5 aspect-[4/5]"
                  : "col-span-6 md:col-span-12 aspect-[21/9]"
              }`}
            >
              <img
                src={src}
                alt={`MOBY SHOP — galerija ${i + 1}`}
                className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms] ease-out"
              />
              {i === 0 && (
                <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-md rounded-xl px-5 py-3">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-[#D32F2F] font-bold">
                    Lokacija
                  </div>
                  <div className="text-sm font-bold text-neutral-900">{STORE.address}</div>
                </div>
              )}
            </motion.div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 pt-12 border-t border-neutral-200">
          {[
            { num: `${years}+`, label: "Godina rada" },
            { num: "1000+", label: "Zadovoljnih kupaca" },
            { num: "2", label: "Trgovine pod krovom" },
            { num: "100%", label: "Lokalno povjerenje" },
          ].map((s, i) => (
            <div key={i} data-testid={`stat-${i}`}>
              <div
                className="text-4xl lg:text-5xl font-extrabold text-[#D32F2F]"
                style={{ fontFamily: "Cabinet Grotesk" }}
              >
                {s.num}
              </div>
              <div className="text-sm text-neutral-500 uppercase tracking-wider mt-1">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
